import GBETHelper from "../gbetutils";

class CasinoUtils {
    static playGame(thisComponent, game, forReal, isMobile, sameTab) {

        sameTab = isMobile;
        if (thisComponent.state.isBlockedFromGames) {
            return false;
        }
        const gameProvidersConfig = GBEglobal.settings.gameProvidersConfig;
        let gameProviderName;

        if (!thisComponent.state.userContext) {
            thisComponent.onLoginWidgetShow(true);

            return;
        }

        window.blur();

        // "game" from CASINO is OBJECT and from MiniGames Widget its an array
        if (Array.isArray(game)) {
            gameProviderName = game.gameProvider;
        } else {
            gameProviderName = game.id.substring(0, game.id.indexOf("."));
        }

        var gameProvider = gameProvidersConfig.web.providers.find((p) => p.key === gameProviderName);
        console.log(gameProvider.key);

        const properties = "status=no,width=960, top=25, left=20, height=650,scrollbars=no,menubar=no,titlebar=no,toolbar=no,resizable=yes";

        if (!sameTab) {
            if (window.gbetGameWindow !== undefined) {
                //we close so that we can reopen and inject loading/error html
                window.gbetGameWindow.close();
            }
            window.gbetGameWindow = window.open(undefined, "gameWindow", properties);
            window.gbetGameWindow.focus();

            //if (window.gbetGameWindow === undefined || window.gbetGameWindow.closed) {
            //    window.gbetGameWindow = window.open(undefined, "gameWindow", properties);
            //} else {
            //    window.gbetGameWindow.focus();
            //}

            //window.gbetGameWindow.document.body.innerHTML = "loading <b>"  + game.name + "</b>...";
        }

        switch (gameProvider.key) {
            case "WACSGames":
                thisComponent.props.controller.getExternalSystemToken({
                    externalSystemName: "WACS",
                    nameValuePairs: [{ name: "channel", value: isMobile ? "M" : "W" }],
                    callbackOnSuccess: function (returnParams) {

                        let url = gameProvider.baseURL.replace("{token}", returnParams.token);
                        url = url.replace("{gameCode}", game.code);
                        url = url.replace("{type}", forReal ? "CHARGED" : "FREE");

                        if (sameTab) {
                            window.location = url;
                        } else {
                            window.gbetGameWindow.location = url;
                        }
                    },
                    callbackOnException: function (response) {
                        console.error(response.returnCode);
                    }
                });

                break;

            case "VFGames":
                thisComponent.props.controller.getExternalSystemToken({
                    externalSystemName: "GTSMiniGames",
                    nameValuePairs: [{ name: "channel", value: isMobile ? "M" : "W" }],
                    callbackOnSuccess: function (returnParams) {

                        let url = gameProvider.baseURL;

                        url += "?gameType=" + game.code;
                        url += "&token=" + returnParams.token;
                        url += forReal ? "" : "&forMoney=false";
                        url += "&region=" + thisComponent.state.userContext.currency + " Global";

                        if (sameTab) {
                            window.location = url;
                        } else {
                            window.gbetGameWindow.location = url;
                        }

                    },
                    callbackOnException: function (response) {
                        console.error(response.returnCode);
                    }
                });

                break;

            case "GVCGames":
                thisComponent.props.controller.getExternalSystemToken({
                    externalSystemName: "GVCGames",
                    nameValuePairs: [{ name: "channel", value: isMobile ? "M" : "W" }],
                    callbackOnSuccess: function (returnParams) {

                        let url = gameProvider.baseURL;

                        var isUKGC = ["uk", "je", "gg", "im"].indexOf(thisComponent.state.userContext.country) > -1;

                        url += "?userId=" + thisComponent.state.userContext.punterId;
                        url += "&frontendId=bq";
                        url += "&brandId=" + configurationSettings.whiteLabel.toUpperCase();
                        url += "&productId=CASINO";
                        url += "&channelId=" + (isMobile ? "AW" : "FC");
                        url += "&lang=en-US";
                        url += "&gameName=" + game.code;
                        url += "&gameDisplayName=" + game.name;
                        url += "&bpToken=" + returnParams.token;
                        url += "&lobbyURL=" + configurationSettings.baseUrl + "casino";
                        url += "&currency=" + thisComponent.state.userContext.currency;
                        url += "&isUKGC=" + isUKGC;
                        url += "&broker=" + configurationSettings.brokerId;
                        url += "&gamehistoryurl=" + String.format(configurationSettings.accountSiteUrl, "account-statement?f=games");

                        if (sameTab) {
                            window.location = url;
                        } else {
                            window.gbetGameWindow.location = url;
                        }
                    },
                    callbackOnException: function (response) {
                        console.error(response.returnCode);
                    }
                });

                break;

            case "Evolution":

                thisComponent.props.controller.performCustomService({
                    "language": "en",
                    "customServiceName": "GetEvolutionUrl",
                    "nameValuePairs": [
                        {
                            "name": "nickname",
                            "value": ""
                        },
                        {
                            "name": "wrapped",
                            "value": "False"
                        },
                        {
                            "name": "mobile",
                            "value": isMobile ? "True" : "False"
                        },
                        {
                            "name": "gameCategory",
                            "value": game.category || game.gameCategory || "rng"
                        },
                        {
                            "name": "gameTableId",
                            "value": game.code
                        }
                    ],
                    callbackOnSuccess: function (resp) {

                        const entry = resp.nameValuePairs.find((o) => o.name === "entry");

                        if (sameTab) {
                            window.location = entry.value;
                        } else {
                            window.gbetGameWindow.location = entry.value;
                        }
                    },
                    callbackOnException: function (resp) {
                        if (window.gbetGameWindow !== undefined && !window.gbetGameWindow.closed) {
                            window.gbetGameWindow.document.body.innerHTML = "Unable to load <b>" + game.name + "</b> at this time. Please try another game. Error: " + resp.returnCode;
                        }

                        console.error(resp);
                    }
                });

                break;
        }
    }

    static getPageTitle(path, gameGroup, configurationSettings) {

        const groupName = (gameGroup === undefined) ? "Home" : gameGroup.name;

        let pageTitle;
        switch (groupName) {
            case "Home":
                pageTitle = "Online Casino Games UK | %whitelabel%";
                break;
            case "Arcade":
                pageTitle = "Online " + groupName?.toLowerCase() + " Games | %whitelabel%";
                break;
            case "All Table Games":
                pageTitle = "All Online Table Games | %whitelabel%";
                break;
            case "All Jackpots":
                pageTitle = "All Online Jackpots | %whitelabel%";
                break;
            case "Exclusive Jackpots":
                pageTitle = "Exclusive Jackpots | %whitelabel%";
                break;
            case "Exclusive Slots":
                pageTitle = "Exclusive Slots | %whitelabel%";
                break;
            case "100k Jackpots":
                pageTitle = "100K Jackpot Casino Games | %whitelabel%";
                break;
            case "150k Jackpots":
                pageTitle = "150K Jackpot Casino Games | %whitelabel%";
                break;
            case "250k Jackpots":
                pageTitle = "250K Jackpot Casino Games | %whitelabel%";
                break;
            case undefined:
                pageTitle = "Online Casino Games UK | %whitelabel%";
                break;
            default:
                pageTitle = groupName?.toLowerCase() + " Games | %whitelabel%";
                break;
        }

        pageTitle = pageTitle.split(" ").map((word) => {
            if (word === "%whitelabel%") {
                return word;
            } else {
                return word[0].toUpperCase() + word.slice(1);
            }
        }).join(" ");

        return pageTitle.replace("Games Games", "Games").replace(/%whitelabel%/g, configurationSettings.whitelabelDisplayName);
    }

    static getPageDescription(path, gameGroup, configurationSettings) {
        const { whitelabelDisplayName } = configurationSettings;
        const groupName = (gameGroup === undefined) ? "Home" : gameGroup.name;

        if (groupName === "Home" || groupName === undefined) {
            return (
                `${whitelabelDisplayName} casino offers a wide array of online casino games, table games, jackpots, exclusive slots; ` +
                `✓${whitelabelDisplayName} Exchange ✓Sportsbook ✓Casino ✓New Customers Offers. We also offer Exchange Betting, Sportsbook, Multiples and Promotions.`
            );
        }

        return this.buildCasinoDescription(gameGroup, groupName, whitelabelDisplayName);
    }

    static buildCasinoDescription(gamesData, groupName, whitelabelDisplayName) {
        let firstGame = null;
        let secondGame = null;
        let thirdGame = null;
        let casinoCategoryName;

        try {
            firstGame = " ";
            firstGame += gamesData.gamesDetails[0].name;
            firstGame += ", ";
            secondGame = gamesData.gamesDetails[1].name;
            secondGame += ", ";
            thirdGame = gamesData.gamesDetails[2].name;
            thirdGame += ", ";
        } catch (_) {
            // ignored
        }

        casinoCategoryName = GBETHelper.toTitleCase(groupName);
        casinoCategoryName += " Games";
        casinoCategoryName = casinoCategoryName.replace("Games Games", "Games");

        let pageDescription =
            `Join ${whitelabelDisplayName} to play the latest ${casinoCategoryName} like${firstGame ?? ""}${secondGame ?? ""}${thirdGame ?? ""}and more`;

        if (firstGame !== " " && pageDescription.includes(",")) {
            pageDescription = pageDescription.replace(/,([^,]*)$/, "$1");
        }

        if (firstGame !== " ") {
            return pageDescription;
        }

        pageDescription = pageDescription.replace(" and more", "");
        pageDescription = pageDescription.replace(" like", "");

        return pageDescription.trim();
    }
}
export default CasinoUtils;